<div class="d-flex flex-column w-100">
    <h2 class="page-header" *ngIf="!smallHeader">{{headingText}} <span class="badge text-bg-info">{{getTotal()}}</span></h2>
    <p class="page-header mb-0" *ngIf="smallHeader">{{headingText}} <span class="badge text-bg-info">{{getTotal()}}</span></p>
    <div class="d-flex flex-fill">
        <ag-grid-angular class="ag-theme-alpine w-100"
                         [rowData]="merchantAccounts"
                         [gridOptions]="gridOptions"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>
